import { CountrySelectEntity } from "./country_select.entity";

export default CountrySelectEntity;
